export const APPLICATION_IDENTIFIER = "X-Application-Identifier";
